/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B4_TInputs */

const en_mk_abt_b4_t = /** @type {(inputs: Mk_Abt_B4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honesty is cheaper than disappointment`)
};

const id_mk_abt_b4_t = /** @type {(inputs: Mk_Abt_B4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kejujuran lebih murah daripada kekecewaan`)
};

/**
* | output |
* | --- |
* | "Honesty is cheaper than disappointment" |
*
* @param {Mk_Abt_B4_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b4_t = /** @type {((inputs?: Mk_Abt_B4_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B4_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b4_t(inputs)
	return en_mk_abt_b4_t(inputs)
});